export enum ROOM_MODE_OPTIONS {
  FURNISH_EMPTY_ROOM = 'furnishEmptyRoom',
  CHANGE_STYLE = 'changeStyle',
  FURNITURE_REMOVAL = 'furnitureRemoval',
  CHANGE_FLOOR = 'changeFloor',
  CLEAN_ROOM = 'cleanRoom',
  IMPROVE_IMAGE_QUALITY = 'improveImageQuality',
  GOOD_WEATHER = 'goodWeather',
}

export enum ROOM_TYPE_OPTIONS {
  LIVING_ROOM = 'living room',
  BEDROOM = 'bedroom',
  KITCHEN = 'kitchen',
  DINING_ROOM = 'dining room',
  KITCHEN_LIVING_COMBO = 'kitchen living combo',
  BATHROOM = 'bathroom',
}

export enum DESIRED_STYLE_OPTIONS {
  ELEGENT = 'elegant',
  SUSTAINABLE_DESIGN = 'sustainable design',
  CURVES_AND_ORGANIC_SHAPES = 'curves and organic shapes',
  RETRO_AND_VINTAGE = 'retro and vintage',
  MINIMALIST = 'minimalist',
  INDUSTRIAL = 'industrial',
  SCANDINAVIAN = 'scandinavian',
  RUSTIC = 'rustic',
  CONTEMPORARY = 'contemporary',
  MID_CENTURY_MODERN = 'mid-century modern',
  FRENCH_COUNTRY = 'french country',
  COASTAL = 'coastal',
  ART_DECO = 'art deco',
  BOHO_CHIC = 'boho chic',
  URBAN_MODERN = 'urban modern',
  MEDITERRANEAN = 'mediterranean',
  MOROCCAN = 'moroccan',
  VICTORIAN = 'victorian',
}

export enum DESIRED_COLOR_OPTIONS {
  WHITE = 'white',
  BLACK = 'black',
  BLUE = 'blue',
  RED = 'red',
  GREEN = 'green',
  YELLOW = 'yellow',
  GRAY = 'gray',
  BROWN = 'brown',
  ORANGE = 'orange',
  PURPLE = 'purple',
  PINK = 'pink',
  BEIGE = 'beige',
  GOLD = 'gold',
  SILVER = 'silver',
  BRONZE = 'bronze',
}

export enum MATERIAL_OPTIONS {
  WOOD = 'wood',
  LEATHER = 'leather',
  COPPER = 'copper',
  STEEL = 'steel',
  GLASS = 'glass',
  MARBLE = 'marble',
  GRANITE = 'granite',
  CONCRETE = 'concrete',
  BRICK = 'brick',
  CERAMIC = 'ceramic',
  PORCELAIN = 'porcelain',
  BAMBOO = 'bamboo',
  VELVET = 'velvet',
  COTTON = 'cotton',
  RATTAN = 'rattan',
}
